/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export const tManager = t.type({
  id: t.number,
  email: t.string,
  phone: t.string,
  name: t.string,
  internal: t.boolean,
  role: t.union([
    t.literal('client'),
    t.literal('manager'),
    t.literal('staff_member'),
  ]),
  first_name: t.string,
  last_name: t.string,
  accepted_terms_and_conditions: t.boolean,
  permissions: t.array(t.string),
  stores: t.array(t.number),
});

export type Manager = t.TypeOf<typeof tManager>;
